import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgApprove = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 8.4375L10.4801 15.7295C10.0789 16.1186 9.43667 16.1033 9.05443 15.6956L6 12.4375",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})
});
export default SvgApprove;
